// todo values could be different
export const availableToList = [
  { label: "FOR_EVERYONE", value: "1" },
  { label: "FOR_FOLLOWERS", value: "2" },
  { label: "FOR_FANS", value: "3" },
];

export const HOST = "host";
export const AUDIENCE = "audience";

//todo delete this variable (it's for testing)
export const FACING_MODS = {
  rear: "environment",
  front: "user",
};

export const roles = {
  viewer: 1,
  moderator: 2,
  creator: 3,
};

export const listTypes = {
  moderator: 1,
  tipper: 2,
  viewer: 3,
};

export const messageTypes = {
  text: 1,
  userJoined: 2,
  tip: 3,
};

export const livestreamStatuses = {
  live: 1,
  ended: 2,
  scheduled: 3,
};

export const paginationLimit = 3;

export const BANNED_ERROR_CODE = "USER_IS_BANNED";

export const POLLING_TIMEOUT = 5000;

export const UNMUTE_TIMEOUT = 300000;

export const TipperHighlightType = {
  0: "goldTipper",
  1: "silverTipper",
  2: "bronzeTipper",
};

export const inviteCoStreamerStatuses = {
  invited: 1,
  accepted: 2,
  noInvited: 3,
  coStreamer: 4,
};

export const streamWindowsItemTypes = {
  remoteUser: 1,
  localUser: 2,
  cover: 3,
};

export const BUTTON_ACTION_TIMEOUT = 20;

export const gameStatuses = {
  start: 1,
  spin: 2,
  close: 3,
  reset: 4,
};

export const gameTypes = {
  spinTheWheel: 0,
  spinTheBottle: 1,
};

export const MAX_STREAMERS_COUNT = 4;
